// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".conclusion-message p,.conclusion-message p strong{color:#fff!important;margin:0!important}", ""]);
// Exports
module.exports = exports;
